import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function TheArtOfTheAura() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll();
  return <section data-section-id="12600" id="curated-beauty-rituals" className="bg-background text-foreground relative h-screen w-full overflow-hidden flex flex-col items-center justify-center">
      {}
      <div className="absolute inset-0 z-0">
        <video autoPlay loop muted playsInline className="h-full w-full object-cover opacity-30 contrast-100" poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/serene_luxury_beauty_sanctuary.png">
          {}
          <source src="/videos/lens-aura-loop.mp4" type="video/mp4" />
        </video>
        {}
        <div className="absolute inset-0 bg-primary/10 mix-blend-soft-light" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-transparent to-secondary/20" />
      </div>

      {}
      <div className="pointer-events-none absolute inset-0 z-10 p-6 md:p-12">
        <div className="h-full w-full relative border-border/20">
          {}
          <div className="absolute top-0 left-0 h-16 w-16 border-t border-l border-ring/40" />
          {}
          <div className="absolute top-0 right-0 h-16 w-16 border-t border-r border-ring/40" />
          {}
          <div className="absolute bottom-0 left-0 h-16 w-16 border-b border-l border-ring/40" />
          {}
          <div className="absolute bottom-0 right-0 h-16 w-16 border-b border-r border-ring/40" />
        </div>
      </div>

      {}
      <div ref={textRef} className={cn("relative z-20 flex flex-col items-center text-center px-4 transition-all duration-1000 ease-out transform", textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h1 className="font-serif text-5xl md:text-7xl lg:text-[120px] font-light text-foreground tracking-wide animate-float drop-shadow-sm">Your Local Beauty Escape in Brooke</h1>
        <p className="mt-8 font-sans text-xs md:text-sm tracking-widest text-muted-foreground uppercase">Relax, refresh, and feel your best at Natalia’s Beauty.</p>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2">
        <div className="w-[1px] bg-ring/60 shadow-[0_0_10px_var(--ring)] animate-[pulse_3s_ease-in-out_infinite] h-16 origin-top scale-y-100" />
      </div>

      {}
      <style jsx>{`
        @keyframes grow-shrink {
          0%, 100% { height: 3rem; opacity: 0.5; }
          50% { height: 6rem; opacity: 1; }
        }
        @keyframes float {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-5px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
      `}</style>
    </section>;
}